import React, { useEffect, useState } from "react";

// const TEACHER_API = "http://localhost:9090/api/teachers";
// const MATERIAL_API = "http://localhost:9090/api/materials"; // Aapka multer wala route yahan mounted hona chahiye
const TEACHER_API = "https://node-api.mediitacademy.com/api/teachers";
const MATERIAL_API = "https://node-api.mediitacademy.com/api/materials"; // Aapka multer wala route yahan mounted hona chahiye

export default function TeacherMaterials() {
  const [materials, setMaterials] = useState<any[]>([]);
  const [batches, setBatches] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  // Text Form Data
  const [form, setForm] = useState({
    title: "",
    type: "PDF",
    batchId: "",
    description: ""
  });
  
  // Actual File State
  const [file, setFile] = useState<File | null>(null);

  const authHeaders = () => {
    const token = localStorage.getItem("token") || "";
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
  };

  useEffect(() => {
    fetchBatches();
    fetchMaterials();
  }, []);

  const fetchBatches = async () => {
    try {
      const res = await fetch(`${TEACHER_API}/me/batches`, {
        headers: { "Content-Type": "application/json", ...authHeaders() }
      });
      if (res.ok) {
        const data = await res.json();
        setBatches(data.batches || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMaterials = async () => {
    setLoading(true);
    try {
      // Fetching from your existing GET / route
      const res = await fetch(MATERIAL_API, { headers: authHeaders() });
      if (res.ok) {
        const data = await res.json();
        setMaterials(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadMaterial = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.title || !form.batchId || !file) {
      alert("Please fill all fields and select a file!");
      return;
    }

    setUploading(true);

    // FormData banayenge kyunki Multer ko yehi format chahiye file receive karne ke liye
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("type", form.type);
    formData.append("batchId", form.batchId);
    formData.append("description", form.description);
    formData.append("file", file); // Multer expects 'file' key

    try {
      // Note: FormData bhejte waqt 'Content-Type' manually set nahi karte hain, browser khud boundary set karta hai
      const res = await fetch(MATERIAL_API, {
        method: "POST",
        headers: authHeaders(), 
        body: formData
      });

      if (!res.ok) throw new Error("Failed to upload material");
      
      alert("Material uploaded successfully to server! 🚀");
      setForm({ title: "", type: "PDF", batchId: "", description: "" });
      setFile(null);
      fetchMaterials();
    } catch (err) {
      alert("Error uploading file. Make sure backend is running.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="max-w-6xl space-y-6 font-['Inter']">
      <header className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-3xl font-black text-slate-950">Study Material & Notes</h2>
        <p className="mt-2 text-sm font-bold text-slate-500">
          Upload PDF notes or documents directly to the server for your batches.
        </p>
      </header>

      <div className="grid gap-6 xl:grid-cols-[400px_1fr]">
        {/* FILE UPLOAD FORM */}
        <form onSubmit={handleUploadMaterial} className="h-fit rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm space-y-4">
          <h3 className="text-xl font-black text-slate-950">Upload New File</h3>
          
          <div>
            <label className="mb-1 block text-xs font-black uppercase text-slate-500">Select Batch</label>
            <select value={form.batchId} onChange={(e) => setForm({...form, batchId: e.target.value})} className="w-full h-11 rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm font-bold outline-none" required>
              <option value="">-- Choose Batch --</option>
              {batches.map(b => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-1 block text-xs font-black uppercase text-slate-500">Document Title</label>
            <input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} placeholder="e.g. Chapter 1 Notes" className="w-full h-11 rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm font-bold outline-none" required />
          </div>

          <div>
            <label className="mb-1 block text-xs font-black uppercase text-slate-500">Material Type</label>
            <select value={form.type} onChange={(e) => setForm({...form, type: e.target.value})} className="w-full h-11 rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm font-bold outline-none">
              <option value="PDF">PDF Document</option>
              <option value="Image">Image / Notes</option>
              <option value="Video">Video File</option>
            </select>
          </div>

         <div>
            <label className="mb-1 block text-xs font-black uppercase text-slate-500">Description (Optional)</label>
            <input value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} placeholder="Short description..." className="w-full h-11 rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm font-bold outline-none" />
          </div>

          <div>
            <label className="mb-1 block text-xs font-black uppercase text-slate-500">Select File</label>
            <input 
              type="file" 
              onChange={(e) => setFile(e.target.files?.[0] || null)} 
              className="w-full text-xs text-slate-500 file:mr-3 file:py-2 file:px-4 file:rounded-xl file:border-0 file:text-xs file:font-black file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" 
              required 
            />
          </div>

          <button type="submit" disabled={uploading} className="w-full rounded-xl bg-blue-600 py-3 text-xs font-black text-white hover:bg-blue-700 disabled:bg-slate-300">
            {uploading ? "Uploading to Server..." : "+ Upload Material 🚀"}
          </button>
        </form>

        {/* UPLOADED MATERIALS LIST */}
        <div className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
          <h3 className="mb-5 text-xl font-black text-slate-950">Server Uploads ({materials.length})</h3>
          {loading ? (
            <p className="text-center text-sm font-bold text-slate-400 py-10">Loading files...</p>
          ) : materials.length === 0 ? (
            <p className="text-center text-sm font-bold text-slate-400 py-10">No materials found in server.</p>
          ) : (
            <div className="space-y-3">
              {materials.map((m) => (
                <div key={m.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-2xl border border-slate-100 bg-[#f8fbff] p-4">
                  <div>
                    <span className="mb-1 inline-block rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-blue-700">
                      {m.type}
                    </span>
                    <p className="text-sm font-black text-slate-900">{m.title}</p>
                    <p className="text-xs font-bold text-slate-400">{m.description}</p>
                  </div>
                  <a 
                    // href={`http://localhost:9090${m.file_url}`} 
                    href={`https://node-api.mediitacademy.com${m.file_url}`} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="shrink-0 rounded-xl bg-white border border-slate-200 px-4 py-2 text-xs font-black text-blue-600 hover:bg-blue-50 text-center"
                  >
                    View File 📂
                  </a>
                </div>
              ))}.
            </div>
          )}
        </div>
      </div>
    </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
  );
}